import 'rxjs/add/operator/debounceTime';
import {Component, QueryList, ViewChildren} from '@angular/core';
import {DateTime, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TFieldType, TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {TFilterOpera} from "../../../pipes/filter-field/filter-field";
import {TAction} from "../../../app/enum";

import {LogadoService} from '../../../providers/logado-service';
import {ProfileRepository} from "../../../repositories/profile-repository";
import {ProfileService} from "../../../providers/profile-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {HotspotRepository} from "../../../repositories/hotspot-repository";
import {ModalFieldPage} from "../modal-field/modal-field";
import {NegocioMenuPage} from "../negocio-menu/negocio-menu";


@Component({
    selector: 'page-unidade-menu',
    templateUrl: 'unidade-menu.html',
    providers: [HotspotService, HotspotRepository, ProfileRepository, ProfileService]
})
export class UnidadeMenuPage {

    @ViewChildren(DateTime) dateTime: QueryList<DateTime>;

    TFilterOpera: any = TFilterOpera;

    config: any;
    logado: any;
    perfil: any;

    etapa: number;

    rootspot: any;
    copyspot: any;

    linenew: any;

    constructor(private viewCtrl: ViewController, public navParams: NavParams,
                public util: Util,
                public logadoService: LogadoService, public profileService: ProfileService,
                public hotspotService: HotspotService, public hotspotRepository: HotspotRepository,
                public profileRepository: ProfileRepository) {

        this.config = CONFIG;

        this.logado = this.logadoService.getAuth();
        this.perfil = this.navParams.get('perfil');

        this.etapa = this.navParams.get('etapa');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Hotlink', '/webstor/hotspot-link');

        this.unidadeLoad();

    }

    ionViewDidLoad() {

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        if (this.etapa == 0) return 'Unidade';

    }


    /** ************************************************* UNIDADE ************************************************* **/
    /** *********************************************************************************************************** **/
    unidadeLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.unidade(TAction.acLoad, 0, this.rootspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.rootspot.Unidades = data.Unidades;
                    this.util.populateObj(this.copyspot, this.rootspot);

                },
                erro => {

                    this.util.alertResult(erro, () => this.dismiss());

                });

    }

    unidadeSave(that, acLixo?) {

        let json = {'Unidades': this.copyspot.Unidades};

        let loading = this.util.loadingDots();
        loading.present();

        let action = (acLixo ? TAction.acLixo : TAction.acSave);
        this.hotspotService.unidade(action, 0, this.copyspot.Hotspots[0].HotspotID, 0, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (data.Codigo) this.copyspot.Unidades[0].UnidadeID = data.Codigo;
                    this.util.populateObj(this.rootspot, this.copyspot);
                    if (that) that.dismiss();

                },
                erro => {

                    this.copyspot.Unidades = [];
                    this.util.alertPopula(erro, this.rootspot, this.copyspot);
                    this.util.populateObj(this.copyspot, this.rootspot);

                });

    }

    unidadeLixo(line) {

        this.util.alertObserv('DELETE', 'Deseja excluir a unidade?', 'Continuar').subscribe(
            () => {

                //let index = this.copyspot.Unidades.indexOf(line);
                //this.copyspot.Unidades.splice(index, 1);
                //line._deleted = true;
                //this.unidadeSave(null, true);

            },
            () => {});

    }

    unidadeNova(done) {

        if (done && this.linenew.UnidadeID == 0) {
            this.copyspot.Unidades.unshift(this.linenew);
            this.util.populateObj(this.rootspot, this.copyspot);
            this.unidadeSave(null);
            this.linenew = null;
            return;
        }

        let datenew = this.util.dateToStr(null);
        this.linenew = {UnidadeID: 0, UnidadeNome: '', UnidadeOpen: datenew, UnidadeShut: '', Branded: {}};
        this.brandedLine(this.linenew);

    }


    unidadeMenu(line) {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Brand',  handler: () => this.brandedLine(line)});
        buttons.push({text: 'Nome',   handler: () => this.unidadeNome(line)});
        buttons.push({text: 'Data',   handler: () => this.unidadeData(line)});
        buttons.push({text: 'Delete', handler: () => this.unidadeLixo(line), role: 'destructive'});
        this.util.sheetOpen(buttons, 'UNIDADE');

    }

    unidadeData(line) {

        if (line.UnidadeID == 0) {
            this.dateTime.toArray()[0].open();
            return;
        }

        let index = this.copyspot.Unidades.indexOf(line);
        this.dateTime.toArray()[index+1].open();

    }

    unidadeNome(line) {

        let onOkiy = (that, okiy, index, isLast) => {
            line.UnidadeNome = okiy[0].groups[0].fields[0].value;
            if (line.UnidadeID == 0) {
                that.dismiss();
                this.unidadeData(line);
            }
            if (line.UnidadeID > 0) {
                this.unidadeSave(that);
            }
        };


        /** SLIDE 01 **/
        let fieldNick = this.config.modalField(TFieldType.ftLine, 'Unidade', null, null, line.UnidadeNome, null, null);
        let groupNick = this.config.modalGroup(null, [fieldNick]);

        let slideFull = this.config.modalSlide('Unidade', null, 'Apelido', 'b-icon-home', 'CorRoxa', [groupNick]);
        this.util.modalopen(ModalFieldPage, 'quad', true, {slides: [slideFull], onOkiy: onOkiy}).subscribe();

    }

    brandedLine(unidade) {

        let object = {etapa: 0, rootile: this.perfil, partnerID: 0};
        this.util.modalopen(NegocioMenuPage, 'alto', false, object).subscribe(data => {

            this.util.populateObj(unidade.Branded, data);

            if (unidade.UnidadeID == 0) {
                this.unidadeNome(this.linenew);
                return;
            }

            this.unidadeSave(this);

        });

    }

    dismiss() {

        this.viewCtrl.dismiss();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/unidade-menu/unidade-menu.ts